const GEOCODE_CACHE = new Map();
const CACHE_TTL_MS = 5 * 60 * 1000;

const toCacheKey = (latitude, longitude) => {
  // Round coordinates to reduce duplicate reverse-geocode calls.
  const lat = Number(latitude).toFixed(4);
  const lon = Number(longitude).toFixed(4);
  return `${lat},${lon}`;
};

const fallbackAddress = (latitude, longitude) => `${latitude}, ${longitude}`;

export const reverseGeocode = async (latitude, longitude) => {
  const cacheKey = toCacheKey(latitude, longitude);
  const now = Date.now();
  const cached = GEOCODE_CACHE.get(cacheKey);
  if (cached && now - cached.ts < CACHE_TTL_MS) {
    return cached.value;
  }

  try {
    const response = await fetch(
      `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}&zoom=18&addressdetails=1`,
      {
        headers: {
          'User-Agent': 'ChamCongApp/1.0',
        },
        mode: 'cors',
      }
    ).catch(() => null);

    if (!response || !response.ok) {
      const fallback = fallbackAddress(latitude, longitude);
      GEOCODE_CACHE.set(cacheKey, { ts: now, value: fallback });
      return fallback;
    }

    const data = await response.json();
    const address = data.display_name || fallbackAddress(latitude, longitude);
    GEOCODE_CACHE.set(cacheKey, { ts: now, value: address });
    return address;
  } catch {
    const fallback = fallbackAddress(latitude, longitude);
    GEOCODE_CACHE.set(cacheKey, { ts: now, value: fallback });
    return fallback;
  }
};

